import Main from "@/components/main";
import Layout from '@/components/Layout';
/**
 * iview-admin中meta除了原生参数外可配置的参数:
 * meta: {
 *  title: { String|Number|Function }
 *         显示在侧边栏、面包屑和标签栏的文字
 *         使用'{{ 多语言字段 }}'形式结合多语言使用，例子看多语言的路由配置;
 *         可以传入一个回调函数，参数是当前路由对象，例子看动态路由和带参路由
 *  hideInBread: (false) 设为true后此级路由将不会出现在面包屑中，示例看QQ群路由配置
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  notCache: (false) 设为true后页面在切换标签后不会缓存，如果需要缓存，无需设置这个字段，而且需要设置页面组件name属性和路由配置的name一致
 *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
 *  beforeCloseName: (-) 设置该字段，则在关闭当前tab页时会去'@/router/before-close.js'里寻找该字段名对应的方法，作为关闭前的钩子函数
 * }
 */


// 工况界面部分
export const workRoutes = {
  path: "/workVision",
  name: "workVision",
  component: Layout,
  meta: {
    hideInMenu: true,
    notCache: true,
    title: '工况信息',
  },
  children: [{
    path: "workHensive",
    name: "workHensive",
    meta: {
      hideInMenu: true,
      title: "综合概览",
      notCache: true,
    },
    component: () => import("@/view/comprehensive/index.vue")
  },{
    path: "workData",
    name: "workData",
    meta: {
      hideInMenu: true,
      title: "工况数据",
      notCache: true,
    },
    component: () => import("@/view/workVision/data.vue")
  },{
    path: "workVideo",
    name: "workVideo",
    meta: {
      hideInMenu: true,
      title: "工况视频",
      notCache: true,
    },
    component: () => import("@/view/workVision/video.vue")
  }]
};

// 态势界面部分
export const trendRoutes = {
  path: "/trendVision",
  name: "trendVision",
  component: Layout,
  meta: {
    hideInMenu: true,
    notCache: true,
    title: '态势信息',
  },
  children: [{
    path: "trendHensive",
    name: "trendHensive",
    meta: {
      hideInMenu: true,
      title: "综合概览",
      notCache: true,
    },
    component: () => import("@/view/comprehensive/index.vue")
  },{
    path: "trendPoint",
    name: "trendPoint",
    meta: {
      hideInMenu: true,
      title: "点云信息",
      notCache: true,
    },
    component: () => import("@/view/trendVision/point.vue")
    },
  {
    path: "trendAbnormal",
    name: "trendAbnormal",
    meta: {
      hideInMenu: true,
      title: "人像数据",
      notCache: true,
    },
    component: () => import("@/view/trendVision/abnormal.vue")
  }]
};


// 监控管理部分
export const monitorRoutes = {
  path: "/monitor",
  name: "monitor",
  component: Layout,
  meta: {
    hideInMenu: true,
    notCache: true,
    title: '监控管理',
  },
  children: [{
    path: "dashboard",
    name: "dashboard",
    meta: {
      hideInMenu: true,
      title: "运行态势看板",
      notCache: true,
    },
    component: () => import("@/view/monitor/dashboard/index.vue")
  }]
};
// 调试工具箱路由(通过控制台debugTool命令打开)
export const debugToolsRoute = {
  path: "/debug-tools",
  name: "debug-tools",
  meta: {
    hideInMenu: true,
    notCache: true,
    title: '调试工具箱',
  },
  component: () => import("@/components/debugTools/index.vue")
};

export const visionRouteList = [workRoutes,trendRoutes,monitorRoutes];

export default [
  //登录界面
  {
    path: "/login",
    name: "login",
    meta: {
      title: "Login - 登录",
      hideInMenu: true
    },
    component: () => import("@/view/login/login.vue")
  },
  //第三方外部登录界面
  {
    path: "/external-login",
    name: "external-login",
    meta: {
      title: "External Login - 第三方登录",
      hideInMenu: true
    },
    component: () => import("@/view/login/external-login.vue")
  },
  workRoutes,
  trendRoutes,
  monitorRoutes,
  debugToolsRoute,
  //首页
  {
    path: "/",
    name: "_home",
    redirect: "/home",
    component: Main,
    meta: {
      hideInMenu: true,
      notCache: true
    },
    children: [
      {
        path: "/home",
        name: "home",
        meta: {
          hideInMenu: true,
          title: "首页",
          notCache: true,
          icon: "md-home"
        },
        component: () => import("@/view/IndexPage/home.vue")
        //component: () => import("@/view/data/position/realTimePosition.vue")
      }
    ]
  },
  {
    path: "/enclosure",
    name: "enclosure",
    title: "电子围栏管理",
    component: Main,
    meta: {
      hideInMenu: false,
      title: "电子围栏管理",
      notCache: true,
      icon: "ios-apps"
    },
    children: [
      {
        path: "electronicfence",
        title: "电子围栏",
        name: "electronicfence",
        meta: {
          hideInMenu: false,
          title: "电子围栏",
          notCache: true,
          icon: "ios-people-outline"
        },
        component: () =>
          import("@/view/enclosure/electronicfence/electronicFenceIndex.vue")
      }
    ]
  },
  {
    path: "/skeletongraphMgmt",
    name: "skeletongraphMgmt",
    title: "骨架图管理",
    component: Main,
    meta: {
      hideInMenu: false,
      title: "骨架图管理",
      notCache: true,
      icon: "ios-apps"
    },
    children: [
      {
        path: "skeletongraph",
        title: "骨架图",
        name: "skeletongraph",
        meta: {
          hideInMenu: false,
          title: "骨架图",
          notCache: true,
          icon: "ios-git-network"
        },
        component: () =>
          import("@/view/skeletonGraph/skeletonGraphIndex.vue")
      }
    ]
  },
  //任务规划
  {
    path: "/task",
    name: "task",
    title: "巡检任务管理",
    component: Main,
    meta: {
      hideInMenu: false,
      title: "巡检任务管理",
      notCache: true,
      icon: "ios-apps"
    },
    children: [
      {
        path: "path",
        title: "作业管理",
        name: "path",
        meta: {
          hideInMenu: false,
          title: "作业管理",
          notCache: true,
          icon: "ios-apps-outline"
        },
        component: () => import("@/view/task/taskPath/pathIndex.vue")
      },
      {
        path: "taskList",
        title: "任务管理",
        name: "taskList",
        meta: {
          hideInMenu: false,
          title: "任务管理",
          notCache: true,
          icon: "ios-apps-outline"
        },
        component: () => import("@/view/task/taskList/taskIndex.vue")
      },
      {
        path: "schedule",
        title: "任务调度管理",
        name: "schedule",
        meta: {
          hideInMenu: false,
          title: "任务调度管理",
          notCache: true,
          icon: "ios-people-outline"
        },
        component: () => import("@/view/task/schedule/scheduleIndex.vue")
      },
      {
        path: "taskExecute",
        title: "任务执行记录",
        name: "taskExecute",
        meta: {
          hideInMenu: false,
          title: "任务执行记录",
          notCache: true,
          icon: "ios-people-outline"
        },
        component: () => import("@/view/task/taskExecute/taskExecuteIndex.vue")
      },
      {
        path: "trackHistory",
        title: "任务轨迹记录",
        name: "trackHistory",
        meta: {
          hideInMenu: false,
          title: "任务轨迹记录",
          notCache: true,
          icon: "ios-people-outline"
        },
        component: () => import("@/view/task/trackHistory/trackHistory.vue")
      }
    ]
  },
  //视频播放
  {
    path: "/data",
    name: "data",
    title: "数据管理",
    meta: {
      hideInMenu: false,
      title: "数据管理",
      notCache: true,
      icon: "ios-compass"
    },
    component: Main,
    children: [
      {
        path: "position",
        title: "实时监控",
        name: "position",
        meta: {
          hideInMenu: false,
          title: "实时监控",
          notCache: true,
          icon: "ios-contacts"
        },
        component: () => import("@/view/data/position/realTimePosition.vue")
      },
      {
        path: "panel",
        title: "数据监控",
        name: "panel",
        meta: {
          hideInMenu: false,
          title: "视频监控",
          notCache: true,
          icon: "ios-contacts"
        },
        component: () => import("@/view/data/panel/index.vue")
      },
      {
        path: "video",
        title: "历史视频",
        name: "video",
        meta: {
          hideInMenu: false,
          title: "历史视频",
          notCache: true,
          icon: "ios-contacts"
        },
        component: () => import("@/view/data/video/historyVideo.vue")
      },
      {
        path: "history",
        title: "历史数据",
        name: "history",
        meta: {
          hideInMenu: false,
          title: "历史数据",
          notCache: true,
          icon: "ios-contacts"
        },
        component: () => import("@/view/data/history/index.vue")
      },
      {
        path: "publish",
        title: "指令下发记录",
        name: "publish",
        meta: {
          hideInMenu: false,
          title: "指令下发记录",
          notCache: true,
          icon: "ios-contacts"
        },
        component: () => import("@/view/data/record/publish.vue")
      },
      {
        path: "cmdResp",
        title: "指令回复记录",
        name: "cmdResp",
        meta: {
          hideInMenu: false,
          title: "指令回复记录",
          notCache: true,
          icon: "ios-contacts"
        },
        component: () => import("@/view/data/record/cmdResp.vue")
      },
      {
        path: "uploadData",
        title: "数据上报记录",
        name: "uploadData",
        meta: {
          hideInMenu: false,
          title: "指令回复记录",
          notCache: true,
          icon: "ios-contacts"
        },
        component: () => import("@/view/data/record/uploadData.vue")
      },
      {
        path: "gunRecord",
        title: "网枪记录",
        name: "gunRecord",
        meta: {
          hideInMenu: false,
          title: "网枪记录",
          notCache: true,
          icon: "ios-contacts"
        },
        component: () => import("@/view/data/gunRecord/gunRecord.vue")
      },
      {
        path: "alarmHandling",
        title: "警情处置记录",
        name: "alarmHandling",
        meta: {
          hideInMenu: false,
          title: "警情处置记录",
          notCache: true,
          icon: "ios-contacts"
        },
        component: () => import("@/view/data/alarmHandling/alarmHandling.vue")
      }
    ]
  },
  //机器人管理
  {
    path: "/robot",
    name: "robot",
    title: "机器人管理",
    meta: {
      hideInMenu: false,
      title: "机器人管理",
      notCache: true,
      icon: "ios-compass"
    },
    component: Main,
    children: [
      {
        path: "list",
        title: "机器人列表",
        name: "list",
        meta: {
          hideInMenu: false,
          title: "机器人列表",
          notCache: true,
          icon: "ios-contacts"
        },
        component: () => import("@/view/robot/list/index.vue")
      },
      {
        path: "repair",
        title: "维修保养",
        name: "repair",
        meta: {
          hideInMenu: false,
          title: "维修保养",
          notCache: true,
          icon: "ios-contacts"
        },
        component: () => import("@/view/robot/repair/index.vue")
      },
      {
        path: "userRobot",
        title: "用户机器人",
        name: "userRobot",
        meta: {
          hideInMenu: false,
          title: "用户机器人",
          notCache: true,
          icon: "ios-contacts"
        },
        component: () => import("@/view/robot/user/index.vue")
      },
      // NEW ADD
      {
        path: "stationManage",
        title: "站点管理",
        name: "stationManage",
        meta: {
          hideInMenu: false,
          title: "站点管理",
          notCache: true,
          icon: "ios-contacts"
        },
        component: () => import("@/view/robot/station/index.vue")
      },
      {
        path: "multicastConfig",
        title: "组播配置",
        name: "multicastConfig",
        meta: {
          hideInMenu: false,
          title: "组播配置",
          notCache: true,
          icon: "ios-contacts"
        },
        component: () => import("@/view/robot/multicastConfig/index.vue")
      }
    ]
  },
  //机器人控制
  {
    path: "/control",
    name: "control",
    title: "机器人控制",
    meta: {
      hideInMenu: false,
      title: "机器人控制",
      notCache: true,
      icon: "ios-compass"
    },
    component: Main,
    children: [
      {
        path: "manage",
        title: "机器人控制",
        name: "manage",
        meta: {
          hideInMenu: false,
          title: "机器人控制",
          notCache: true,
          icon: "ios-contacts"
        },
        component: () => import("@/view/control/manage/index.vue")
      },
      {
        path: "pursuit",
        title: "行为拒止",
        name: "pursuit",
        meta: {
          hideInMenu: false,
          title: "行为拒止",
          notCache: true,
          icon: "ios-locate-outline"
        },
        component: () => import("@/view/data/pursuit/index.vue")
      }
    ]
  },
  //声联智控中心
  {
    path: "/voice",
    name: "voice",
    title: "声联智控中心",
    meta: {
      hideInMenu: false,
      title: "声联智控中心",
      notCache: true,
      icon: "ios-apps"
    },
    component: Main,
    children: [
      {
        path: "intercom",
        title: "语音对讲",
        name: "intercom",
        meta: {
          hideInMenu: false,
          title: "语音对讲",
          notCache: true,
          icon: "ios-contacts"
        },
        component: () => import("@/view/voice/intercom/index.vue")
      },
      {
        path: "MusicPlayback",
        title: "音频播放",
        name: "MusicPlayback",
        meta: {
          hideInMenu: false,
          title: "音频播放",
          notCache: true,
          icon: "ios-contacts"
        },
        component: () => import("@/view/voice/musicPlayback/index.vue")
      },
      {
        path: "MusicUpload",
        title: "音频上传",
        name: "MusicUpload",
        meta: {
          hideInMenu: false,
          title: "音频上传",
          notCache: true,
          icon: "ios-contacts"
        },
        component: () => import("@/view/voice/musicUpload/index.vue")
      },
      {
        path: "audioProperties",
        title: "音频属性",
        name: "audioProperties",
        meta: {
          hideInMenu: false,
          title: "音频属性",
          notCache: true,
          icon: "ios-contacts"
        },
        component: () => import("@/view/robotCommon/left-right/index.vue")
      }
    ]
  },
  //系统管理
  {
    path: "/sys",
    name: "sys",
    title: "系统管理",
    component: Main,
    meta: {
      hideInMenu: false,
      title: "系统管理",
      notCache: true,
      icon: "ios-apps"
    },
    children: [
      {
        path: "organuserctrl",
        title: "用户管理",
        name: "organuserctrl",
        meta: {
          hideInMenu: false,
          title: "用户管理",
          notCache: true,
          icon: "ios-contacts"
        },
        component: () => import("@/view/user/userctrl/userctrl.vue")
      },
      {
        path: "menulistctrl",
        title: "菜单管理",
        name: "menulistctrl",
        meta: {
          hideInMenu: false,
          title: "菜单管理",
          notCache: true,
          icon: "ios-apps-outline"
        },
        component: () => import("@/view/sys/menulistctrl/menulistctrl.vue")
      },
      {
        path: "rolectrl",
        title: "角色管理",
        name: "rolectrl",
        meta: {
          hideInMenu: false,
          title: "角色管理",
          notCache: true,
          icon: "ios-people-outline"
        },
        component: () => import("@/view/sys/role/rolectrl.vue")
      },
      {
        path: "resources",
        title: "资源管理",
        name: "resources",
        meta: {
          hideInMenu: false,
          title: "资源管理",
          notCache: true,
          icon: "ios-people-outline"
        },
        component: () => import("@/view/sys/resources/index.vue")
      },
      {
        path: "server",
        title: "服务列表",
        name: "server",
        meta: {
          hideInMenu: false,
          title: "服务列表",
          notCache: true,
          icon: "ios-people-outline"
        },
        component: () => import("@/view/sys/server/index.vue")
      },
      {
        path: "config",
        title: "配置管理",
        name: "config",
        meta: {
          hideInMenu: false,
          title: "配置管理",
          notCache: true,
          icon: "ios-people-outline"
        },
        component: () => import("@/view/sys/config/index.vue")
      },
      {
        path: "tenant",
        title: "租户管理",
        name: "tenant",
        meta: {
          hideInMenu: false,
          title: "租户管理",
          notCache: true,
          icon: "ios-people-outline"
        },
        component: () => import("@/view/sys/tenant/index.vue")
      },
      {
        path: "tenantOnly",
        title: "我的租户",
        name: "tenantOnly",
        meta: {
          hideInMenu: false,
          title: "我的租户",
          notCache: true,
          icon: "ios-people-outline"
        },
        component: () => import("@/view/sys/tenant/index.vue")
      },
      {
        path: "expose",
        title: "租户三方账户",
        name: "expose",
        meta: {
          hideInMenu: false,
          title: "租户三方账户",
          notCache: true,
          icon: "ios-people-outline"
        },
        component: () => import("@/view/sys/tenant/expose.vue")
      },
      {
        path: "moveRobot",
        title: "租户机器人迁移",
        name: "moveRobot",
        meta: {
          hideInMenu: false,
          title: "租户机器人迁移",
          notCache: true,
          icon: "ios-people-outline"
        },
        component: () => import("@/view/sys/tenant/moveRobot.vue")
      }
    ]
  },
  {
    path: "/log",
    name: "log",
    title: "日志中心",
    meta: {
      hideInMenu: false,
      title: "日志中心",
      notCache: true,
      icon: "ios-albums-outline"
    },
    component: Main,
    children: [
      {
        path: "loginList",
        title: "登录日志",
        name: "loginList",
        meta: {
          hideInMenu: false,
          title: "登录日志",
          notCache: true,
          icon: "ios-contacts"
        },
        component: () => import("@/view/log/login/index.vue")
      },
      {
        path: "operationList",
        title: "操作日志",
        name: "operationList",
        meta: {
          hideInMenu: false,
          title: "操作日志",
          notCache: true,
          icon: "ios-contacts"
        },
        component: () => import("@/view/log/operation/index.vue")
      }
    ]
  },
  //隐藏菜单
  {
    path: "/lol",
    name: "lol",
    meta: {
      hideInMenu: true
    },
    component: () => import("@/view/data/lol/index.vue")
  },
  //智能功能
  {
    path: "/intelligentFunction",
    name: "intelligentFunction",
    title: "智能功能",
    meta: {
      hideInMenu: false,
      title: "智能功能",
      notCache: true,
      icon: "ios-compass"
    },
    component: Main,
    children: [
      {
        path: "SmartConfig",
        title: "智能配置",
        name: "SmartConfig",
        meta: {
          hideInMenu: false,
          title: "智能配置",
          notCache: true,
          icon: "ios-contacts"
        },
        component: () => import("@/view/robotCommon/left-right/index.vue")
      }
    ]
  },
  //错误界面
  {
    path: "/401",
    name: "error_401",
    meta: {
      hideInMenu: true
    },
    component: () => import("@/view/error-page/401.vue")
  },
  {
    path: "/500",
    name: "error_500",
    meta: {
      hideInMenu: true
    },
    component: () => import("@/view/error-page/500.vue")
  },
  {
    path: "*",
    name: "error_404",
    meta: {
      hideInMenu: true
    },
    component: () => import("@/view/error-page/404.vue")
  }
];
